import React, { useState } from 'react';
import { IconButton, Dialog, DialogContent, Tooltip, Badge } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';
import { NotificationPreferences } from '../common/NotificationPreferences';
import { useNotifications } from '../../contexts/NotificationContext';

export const NotificationButton: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { preferences, isLoading } = useNotifications();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Préférences de notifications">
        <IconButton
          color="inherit"
          onClick={handleOpen}
          sx={{ ml: 1 }}
          disabled={isLoading}
        >
          <Badge color="secondary" variant="dot" invisible={!preferences.enabled}>
            {preferences.enabled ? <NotificationsIcon /> : <NotificationsOffIcon />}
          </Badge>
        </IconButton>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent>
          <NotificationPreferences />
        </DialogContent>
      </Dialog>
    </>
  );
};
